export const unimportedTransactionsTableHeaders = () => {

    const baseHeaders = [
        {
            id: 'date',
            label: 'Date',
            sort: false,
        },
        {
            id: 'description',
            label: 'Description',
            sort: false,
        },
        {
            id: 'amount',
            label: 'Amount',
            sort: false,
            render: (row) => `${row.currency_code} ${row.amount}`,
        },
    ];

 

    return [
        ...baseHeaders, 
    ];
};
